import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { formatKvps, Kvps, KvpsKind } from "@/lib/kvps";
import { Badge } from "../ui/badge";

function KvpsComponent({
  kvps,
  noTooltip = false,
}: {
  kvps: Kvps | null;
  noTooltip?: boolean;
}) {
  if (kvps === null) {
    return <span className="text-yellow-600">Aucun KVPS sélectionné</span>;
  }

  const text = formatKvps(kvps);
  const content = (
    <div className="flex flex-row items-center gap-1 overflow-hidden">
      <KvpsKindBadge kind={kvps.kind} />
      <span className="truncate">{text}</span>
    </div>
  );

  if (noTooltip) {
    return content;
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>{content}</TooltipTrigger>
      <TooltipContent align="end">{text}</TooltipContent>
    </Tooltip>
  );
}

function KvpsKindBadge({ kind }: { kind: KvpsKind }) {
  const text = {
    [KvpsKind.AVS]: "AVS",
    [KvpsKind.INTERNAL]: "Interne",
    [KvpsKind.RETAIL]: "Retail",
    [KvpsKind.UNKNOWN]: "Inconnu",
  }[kind];

  return <Badge className="px-1.5 py-0">{text}</Badge>;
}

export { KvpsComponent, KvpsKindBadge };
